export default __webpack_public_path__ + "static/media/search-icon.38ff9361.svg";